import { Alert, AlertDescription, AlertTitle } from 'design-system';
import { Pencil, Settings, X } from 'lucide-react';

export const EditBanner = () => {
  return (
    <Alert className='max-w-2xl border-highlight/40 bg-highlight/5'>
      <Pencil aria-hidden='true' />
      <AlertTitle>Edit Mode</AlertTitle>
      <AlertDescription>
        <ul className='list-square grid gap-1 pl-4'>
          <li>Drag widgets/tabs to reorder them.</li>
          <li className='flex flex-wrap items-center gap-1'>
            Use <Settings className='size-3.5' /> for settings, <X className='size-3.5' /> to
            remove, and “+” to add a tab.
          </li>
          <li>Click “Save” when you’re done.</li>
        </ul>
      </AlertDescription>
    </Alert>
  );
};
